<template>
  <div>
    <b-card class="col-12" no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12">
            <h4>
              Danh sách khách hàng VPBank <a v-b-tooltip.hover.top="'Lấy lại danh sách!'" class="btn-icon"
                                             @click="$router.go()">
              <feather-icon icon="RepeatIcon"/>
            </a>
            </h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="9">
            <b-tabs>
              <b-tab v-for="f in this.status" :key="f.id" :active="selectedTab == f.id" :title="f.text"
                     @click="changeTab(f.id)">
              </b-tab>
            </b-tabs>
          </b-col>
          <b-col class="text-end mb-2" cols="3">
            <vue-excel-xlsx
                :columns="fields.filter(el => el.label != 'Thao tác')"
                :data="exportExcelData"
                :file-name="'Thống kê đơn hàng VPBank'"
                :file-type="'xlsx'"
                :sheet-name="'VPBank'"
                class="border-0 bg-transparent"
            >
              <b-button class="btn" variant="primary">
                Export
              </b-button>
            </vue-excel-xlsx>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <vue-good-table :columns="fields" :isLoading.sync="isLoading" :line-numbers="true"
                            :pagination-options="{ perPage: serverParams.pageSize, enabled: true }" :rows="tableData"
                            :totalRows="totalRecords" mode="remote"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange">
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <span class="action-col">
                    <b-button v-if="props.row.Status == 0 || props.row.Status == 3
                      " class="btn-icon" size="sm" variant="primary" @click="showProcessModal(props.row)">
                      Trả thưởng
                    </b-button>
                    <b-button v-if="props.row.Status == 2 || props.row.Status == 3
                      " class="btn-icon" size="sm" variant="primary" @click="onShowLog(props.row)">
                      Lịch sử
                    </b-button>
                  </span>
                </span>
                <!--                <span-->
                <!--                    v-else-if="props.column.field === 'CreateDate' || props.column.field === 'ApprovedDate' || props.column.field === 'ClaimDate' || props.column.field === 'TopupDate'">-->
                <!--                  {{ getDateTime(props.formattedRow[props.column.field]) }}-->
                <!--                </span>-->
                <span
                    v-else-if="props.column.field === 'Status'">
                  {{ status.find(item => item.id == props.formattedRow[props.column.field]).text }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal
        id="modal-log"
        :title="'Kết quả gọi topop vnpay'"
        ok-only
        ok-title="Đóng"
        size="xl"
    >
      <template>

        <b-row>
          <b-col cols="12">
            <vue-good-table :columns="logFields" :line-numbers="true" :rows="topupLog">
              <template slot="table-row" slot-scope="props">
                <span>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <b-modal
        id="modal-process"
        :title="'Trả thưởng'"
        ok-only
        ok-title="Xác nhận"
        size="sm"
        @ok="onApprove"
    >
      <template>

        <b-row>
          <b-col cols="12">
            <b-form-group label="Hình thức trả thưởng">
              <b-form-radio-group
                  id="radio-group-1"
                  v-model="selectedRecord.type"
                  :options="htttOptions"
                  name="radio-options"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col v-if="selectedRecord.type == 'card'" cols="6">
            <b-form-group label="Nhà mạng">
              <Select2
                  v-model="selectedRecord.provider_code"
                  :options="this.providers"
                  placeholder="Chọn nhà mạng... "
              />
            </b-form-group>
          </b-col>
          <b-col v-if="selectedRecord.type == 'card'" cols="6">
            <b-form-group label="Mệnh giá">
              <b-form-input
                  disabled
                  placeholder="Nhập mệnh giá"
                  value="200,000"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>
<script>


import {ValidationObserver, ValidationProvider} from 'vee-validate'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';
import moment from 'moment';
import flatPickr from 'vue-flatpickr-component'
import Vue from "vue"
import VueExcelXlsx from 'vue-excel-xlsx'

Vue.use(VueExcelXlsx)

export default {

  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCardText,
    BInputGroup,
    flatPickr
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  async mounted() {
    await this.getOutBound();
    await this.getTabTableData();
  },
  computed: {
    getStatus() {
      return this.selectedTab;
    },
    disabledModalField() {
      return this.selectedRecord && (this.selectedRecord.Status != 0)
    },
    exportExcelData() {
      let data = this.exportTableData || [];
      return data.map(el => {
        return {
          ...el,
          Status: (this.status.find(o => o.id == el.Status) || {text: ""}).text
        }
      })
    }
  },
  watch: {},
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      if (this.serverParams.columnFilters.Status == "") {
        delete this.serverParams.columnFilters.Status
      }
    },
    async onPageChange(params) {
      this.serverParams.page = params.currentPage
      this.serverParams.currentPage = params.currentPage
      await this.getTabTableData(true)
    },
    onSortChange(params) {
      this.updateParams(params);
      this.getTabTableData(false);
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.getTabTableData(false);
    },
    async onPerPageChange(params) {
      this.serverParams.pageSize = params.currentPerPage
      await this.getTabTableData(true)
    },
    async onShowLog(row) {
      this.selectedRecord = JSON.parse(JSON.stringify(row));
      let data = {
        "Id": this.selectedRecord.Id
      }
      useJwt.post('aff/get_log', data)
          .then(async response => {
            if (response.data.code == 200) {
              this.logContent = response.data.result[0].Content;
              this.topupLog = response.data.result;
              this.$bvModal.show("modal-log");
              console.log(this.logContent);
            }
          })
          .catch(error => {
          })
    },
    async showProcessModal(row) {
      this.selectedRecord = JSON.parse(JSON.stringify(row));
      this.$bvModal.show("modal-process");
    },
    async onApprove() {
      let data = this.selectedRecord;
      var provider = this.providers.filter(
          (item) => item.providerCode == data.provider_code
      )[0];
      data.vendor_code = provider == null ? '' : provider.vendorCode;
      console.log(provider);
      var res = await this.$bvModal.msgBoxConfirm(
          "Bạn có chắc chắn trả thưởng cho khách hàng?",
          {title: "Vui lòng xác nhận", size: "sm"}
      );
      if (res) {
        useJwt.post('aff/approve', data)
            .then(async response => {
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Xử lý thành công!', icon: 'CheckSquareIcon', variant: 'success'}
              })
              await this.getTabTableData();
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {title: error.response.data.message, icon: 'AlertTriangleIcon', variant: 'danger'}
              })
            })
      }
    },
    async getOutBound() {
      const response = await useJwt.get('aff/meta')
      if (response.data.code == 200) {
        this.status = [{id: -1, text: 'Tất cả'}, ...response.data.result.Status];
      } else {
        this.status = [{id: -1, text: 'Tất cả'}]
      }

      const response1 = await useJwt.get('aff/get-provider')
      if (response1.data.code == 200) {
        this.providers = response1.data.result.map((item) => {
          return {
            id: item.providerCode,
            text: item.name,
            ...item
          };
        });
      }
    },
    getFieldsTable(columns) {
      this.fields = columns.map(c => {
        const key = Object.keys(c)[0];
        return {
          field: key,
          filterOptions: {enabled: true, placeholder: ''},
          label: c[key],
          required: true,
          disabled: true,
          tdClass: 'text-center',
          width: key === "ID" ? '50px' : key === "Status" ? "180px" : "auto"
        }
      })
      this.fields.push({
        field: 'action',
        filterOptions: {enabled: false, placeholder: ''},
        label: 'Thao tác',
        required: true,
        disabled: true,
        width: '170px'
      })
    },
    async getTabTableData(isGetColumn = true) {
      const response = await useJwt.post(`aff/request/${this.getStatus}`, this.serverParams);
      if (response.data.code == 200) {
        this.tableData = response.data.result ? response.data.result : []
        this.totalRecords = response.data.totalRecords
        if (isGetColumn) {
          this.getFieldsTable(response.data.extra.Column)
        }
      } else {
        if (isGetColumn) {
          this.getFieldsTable(response.data.extra.Column)
        }
        this.tableData = [];
        this.totalRecords = 0
      }

      useJwt.post(`aff/request/${this.getStatus}`, {
        ...this.serverParams,
        page: 0,
        pageSize: 0
      }).then(rs => {
        if (rs.data.code == 200) {
          this.exportTableData = rs.data.result ? rs.data.result : []
        }
      })

    },
    async changeTab(e) {
      this.selectedTab = e;
      await this.getTabTableData();
    },
    getDateTime(e) {
      return moment(e).isValid() ? moment(e).format('DD/MM/YYYY HH:mm:ss') : ''
    },
  },
  data() {
    return {
      selectedTab: -1,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50
      },
      totalRecords: 0,
      isLoading: false,
      group: [],
      status: [],
      tableData: [],
      exportTableData: [],
      selectedRecord: {},
      logContent: null,
      topupLog: [],
      fields: [{
        field: 'action',
        filterOptions: {enabled: false, placeholder: ''},
        label: 'Thao tác',
        required: true,
        disabled: true,
        width: '100px'
      }],
      logFields: [
        {
          label: 'Thời gian',
          field: 'LogDate',
        },
        {
          label: 'Nội dung',
          field: 'Content',
        }
      ],
      htttOptions: [
        {text: 'Trả topup', value: 'topup'},
        {text: 'Mua mã thẻ', value: 'card'}
      ],
      providers: []
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.modal-activated-order {
  height: 700px;
  color: #000000;
}

.col-700-scroll {
  height: 680px;
  overflow: auto;
}
</style>
<style scoped>
.error-txt small {
  color: red;
}

.text-end {
  text-align: end;
}

.action-col {
  width: 100%;
  display: flex;
  justify-content: center;
}

.detail-custom-table th,
.detail-custom-table td {
  border: solid 1px rgb(207 207 207);
  padding: 5px 10px;
}

.detail-custom-table th {
  vertical-align: baseline;
}

.history-call__header h5 {
  margin: 0;
}

.btn-icon {
  margin-right: 3px;
}
</style>
